module.exports = __webpack_public_path__ + "img/uni.e19b3310.png";